export default __webpack_public_path__ + "static/media/resume-website.8e893a9f.pdf";